

import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import {Box, Grid, ListItemIcon, ListItemText, Menu, MenuItem, getContrastRatio,} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetState, updateState } from "../../../redux/commonSlice";
import { useLocation, useNavigate } from "react-router-dom";
import "@fontsource/rubik";
import { resetAllMediaFilesArray } from "../../../redux/mediaFilesSlice";
import { resetReviewState } from "../../../redux/reviewSlice";
import { resetSnackbar } from "../../../redux/messageSlice";
import { resetCreationState } from "../../../redux/eventCreationSlice";
import useDeleteUser from "../../dashboard/hooks/useDeleteUser";
import { getInitials, logout } from "../../../utils/commonServices";
import usePermissions from "../../../hooks/usePermissions";
// import { customTheme as theme } from "../../../theme/customTheme";
import { setAssetState } from "../../../redux/assetSlice";
import useCustomTheme from "../../../theme/useCustomTheme";
import { PERMISSION } from "../../../constants/constants";
import { updateTeamState } from "../../../redux/teamSlice";
import { updateProjectState } from "../../../redux/projectSlice";
import BoltIcon from "@mui/icons-material/Bolt";
import { Badge, Tooltip } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  center: {
    //  display:'flex',
    //   alignItems: 'center',
    //   justifyContent:'center'
  },
  text: {
    color: theme.palette.primary.dark,
    fontSize: theme.typography.subtitle2,
    fontWeight: theme.typography.fontWeightBold,
  
  },
}));

const CustomUserCard = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const { avatarImg, userName, size = 'small' } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [hasPermission] = usePermissions();
  const [theme ] = useCustomTheme()
  const location = useLocation();

  const commonReducer = useSelector((state) => state.root.commonReducer);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // const logout = () => {
  //   window.localStorage.removeItem("token");
  //   dispatch(resetAllMediaFilesArray())
  //   dispatch(resetReviewState())
  //   dispatch(resetSnackbar())
  //   dispatch(resetCreationState())
  //   dispatch(resetState());
  //   //   dispatch(updateState({
  //   //     is_logged: false,
  //   // }));
  //   //navigate('/signin');
  // };

  const addMembersClickHandler =()=>{
    if(location?.pathname === '/dashboard'   || location?.pathname === '/usermanagement'){
      dispatch(updateState({invite_org_members_popup : true}))
    }else{
      dispatch(updateProjectState({invite_project_members_popup : true}))
    }
    handleClose()
  }

  const viewMembersClickHandler =()=>{
  if(location?.pathname === '/dashboard'   || location?.pathname === '/usermanagement'){
    dispatch(updateState({view_members_popup: true}))
  }else{
    dispatch(updateProjectState({view_project_members_popup : true}))
  }
   
    handleClose()
  }


 

  const pendingQuickTurnCount = commonReducer?.pending_quick_turn_count ?? 0;

  return (
    <Box
      {...props}
      className='flex row a-center j-center'
      spacing={2}
    >

    {commonReducer?.role_name === 'Admin' && (
      <Tooltip title="Quick Turn Requests" arrow>
        <Box
          onClick={() => navigate('/quickturnrequests')}
          sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', mr: { xs: 1, md: 1.5, xl: 2 } }}
        >
          <Badge
            badgeContent={pendingQuickTurnCount}
            color="warning"
            max={99}
            sx={{
              '& .MuiBadge-badge': {
                fontSize: { xs: '7px', md: '8px', lg: '9px', xl: '12px' },
                height: { xs: '13px', md: '15px', xl: '20px' },
                minWidth: { xs: '13px', md: '15px', xl: '20px' },
                padding: '0 3px',
                fontFamily: 'Rubik',
                fontWeight: 700,
              },
            }}
          >
            <BoltIcon sx={{ fontSize: { xs: '18px', sm: '20px', md: '22px', lg: '24px', xl: '32px' }, color: '#f59e0b' }} />
          </Badge>
        </Box>
      </Tooltip>
    )}

    <Box sx={{display:'flex', cursor:'pointer', justifyContent:'center', alignItems:'center'}}  onClick={commonReducer.is_logged == true && handleClick} gap={2}>

        { 
          size == "small" ?<Avatar sx={{width:{xs:'20px',sm:'24px' ,md:'27px' , lg:'26px' ,xl:'35px'}, height:{xs:'20px',sm:'24px' ,md:'27px' , lg:'26px' ,xl:'35px'},backgroundColor:theme.palette.primary.main, borderRadius:'8px', fontSize:{xs:'8px',md:'10px',lg:'12px',xl:'16px'}, fontWeight: 600, textTransform:'uppercase',  color: '#ffffff'}}>{getInitials(commonReducer.user_name)}</Avatar>
        :  <Avatar sx={{width:{xs:'20px',sm:'22px' ,md:'24px' , lg:'25px' ,xl:'35px'}, height:{xs:'20px',sm:'22px' ,md:'24px' , lg:'25px' ,xl:'35px'},backgroundColor:theme.palette.primary.main, borderRadius:'8px', fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, fontWeight: 600, textTransform:'uppercase',   color:'#ffffff' }}>{getInitials(commonReducer.user_name)}</Avatar>}
        <Typography
          className={classes.text}
          variant="body2"
          sx={{
            fontFamily: 'Rubik',
            fontSize: {xs:'10px',md:'12px',lg:'14px',xl:'20px'},
            fontWeight: 600,
            color: 'black !important',
            textTransform:'capitalize'
          }}
        >
          {commonReducer.is_logged == false
            ? "Guest User"
            : commonReducer.user_name}
        </Typography>

       

    </Box>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        // transformOrigin={{
        // //   vertical: "top",
        // //   horizontal: 133,
        // vertical:-8,
        // horizontal:87
        // }}
        transformOrigin={{
              vertical: -8,
              horizontal: 'right',
             }}
      >

       {location?.pathname === '/dashboard'  || location?.pathname === '/usermanagement' ? <MenuItem
          onClick={()=> 
            commonReducer?.role_name === 'Admin' ? addMembersClickHandler() : viewMembersClickHandler()  
            } 
          sx={{color:'#000',fontWeight:600, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4, height:  {xs:16, sm:25,xl:32}, '&:hover':{backgroundColor:`${theme.palette.primary.main}70`}}}
        >
        {  commonReducer?.role_name === 'Admin' ? 'Manage Organisation Members': 'View Organisation Members'}
        </MenuItem> : <MenuItem
          onClick={()=> 
              commonReducer?.role_name === 'Admin' ? addMembersClickHandler() : viewMembersClickHandler()  
            } 
          sx={{color:'#000',fontWeight:600, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4, height:  {xs:16, sm:25,xl:32}, '&:hover':{backgroundColor:`${theme.palette.primary.main}70`}}}
        >
        {  commonReducer?.role_name === 'Admin' ? 'Manage Project Members': 'View Project Members'}
        </MenuItem>}

        {/* { commonReducer?.is_admin &&  <MenuItem
          onClick={() => {
            if( commonReducer?.is_company_name_available === false){
              dispatch(setAssetState({brand_name_popup: true}))
            }else{ 
              dispatch(updateState({change_theme_popup:true}))
            }
            handleClose();
          }}
          sx={{color:'#000',fontWeight:600, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4, height: {xs:16, sm:25,xl:32},  '&:hover':{backgroundColor:`${theme.palette.primary.main}70`}}}
        >
         Theme and Logo
        </MenuItem>
        } */}

       
      { commonReducer?.role_name === 'Admin' && <MenuItem
          style={{ height: 25 }}
          onClick={() => {

            navigate('/usermanagement')
            handleClose();
          }}
          sx={{'&:hover':{backgroundColor:`${theme.palette.primary.main}70`},color:'#000',fontWeight:600,  height: {xs:16, sm:25,xl:32}, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4}}
        >
         User Management
        </MenuItem>}

      { commonReducer?.role_name === 'Admin' && <MenuItem
          style={{ height: 25 }}
          onClick={() => {
            navigate('/hiddenprojects')
            handleClose();
          }}
          sx={{'&:hover':{backgroundColor:`${theme.palette.primary.main}70`},color:'#000',fontWeight:600, height: {xs:16, sm:25,xl:32}, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4}}
        >
         Hidden Projects
        </MenuItem>}

      { commonReducer?.role_name === 'Admin' && <MenuItem
          style={{ height: 25 }}
          onClick={() => {
            navigate('/productaccess')
            handleClose();
          }}
          sx={{'&:hover':{backgroundColor:`${theme.palette.primary.main}70`},color:'#000',fontWeight:600, height: {xs:16, sm:25,xl:32}, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4}}
        >
         Product Access
        </MenuItem>}

      { commonReducer?.role_name === 'Admin' && <MenuItem
          style={{ height: 25 }}
          onClick={() => {
            navigate('/quickturnrequests')
            handleClose();
          }}
          sx={{'&:hover':{backgroundColor:`${theme.palette.primary.main}70`},color:'#000',fontWeight:600, height: {xs:16, sm:25,xl:32}, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4}}
        >
         Quick Turn Requests
        </MenuItem>}


        {/* <MenuItem
          onClick={() => {
            dispatch(updateState({account_delete_popup : true}))
            setAnchorEl(null)
          }}
          sx={{color:'#000',fontWeight:600, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4, height: {xs:16, sm:25,xl:32},  '&:hover':{backgroundColor:`${theme.palette.primary.main}70`}}}
        >
          Pending Verification
        </MenuItem> */}

        <MenuItem
          onClick={() => {
            logout(dispatch);
            handleClose();
          }}
          sx={{color:'#000',fontWeight:600, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4, height: {xs:16, sm:25,xl:32},  '&:hover':{backgroundColor:`${theme.palette.primary.main}70`}}}
        >
          Log out
        </MenuItem>
       
      </Menu>
    </Box>
  );
};

export default CustomUserCard;